/**
 * BOLD SURFACES — Cinematic Hero
 * v5 — Split-screen | Panoramic | Crossfade slideshow
 */
(function () {
  'use strict';

  /* ────────────────────────────────────────────
     SPLIT-SCREEN MODE
     Mouse-driven parallax + Ken Burns zoom
     Crossfade between images per panel
     ──────────────────────────────────────────── */
  function initSplit() {
    var hero = document.querySelector('[data-hero]');
    var panels = hero.querySelectorAll('.bold-hero__panel');
    if (panels.length < 2) return;

    var CROSSFADE_INTERVAL = 7000;
    var MOUSE_STRENGTH = 12;
    var LERP = 0.04;
    var DRIFT_STRENGTH = 10;           // Max px of gentle auto-drift
    var DRIFT_SPEED = 0.0003;         // Slow cycle (~21s full loop)

    var mouseX = 0, mouseY = 0;
    var smoothX = 0, smoothY = 0;
    var startTime = performance.now();

    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      mouseX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      mouseY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    });

    hero.addEventListener('mouseleave', function () {
      mouseX = 0;
      mouseY = 0;
    });

    function setupPanel(panel, panelIndex) {
      var imgs = panel.querySelectorAll('.bold-hero__panel-img');
      if (!imgs.length) return;

      var currentIdx = 0;

      if (imgs.length > 1) {
        var offset = panelIndex * (CROSSFADE_INTERVAL / 2);
        setTimeout(function startCrossfade() {
          var nextIdx = (currentIdx + 1) % imgs.length;
          imgs[currentIdx].classList.remove('is-active');
          imgs[nextIdx].classList.add('is-active');
          currentIdx = nextIdx;
          setTimeout(startCrossfade, CROSSFADE_INTERVAL);
        }, CROSSFADE_INTERVAL + offset);
      }

      // Phase offset so panels drift in opposite directions
      var phaseOffset = panelIndex * Math.PI;

      function animate(now) {
        smoothX += (mouseX - smoothX) * LERP;
        smoothY += (mouseY - smoothY) * LERP;

        // Subtle ambient drift (sine wave)
        var elapsed = now - startTime;
        var driftX = Math.sin(elapsed * DRIFT_SPEED + phaseOffset) * DRIFT_STRENGTH;
        var driftY = Math.cos(elapsed * DRIFT_SPEED * 0.7 + phaseOffset) * DRIFT_STRENGTH * 0.5;

        // Mouse parallax (opposite per panel)
        var dirX = panelIndex === 0 ? -1 : 1;
        var tx = smoothX * MOUSE_STRENGTH * dirX + driftX;
        var ty = smoothY * MOUSE_STRENGTH * -1 + driftY;

        for (var i = 0; i < imgs.length; i++) {
          imgs[i].style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0) scale(1.06)';
        }

        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);
    }

    setupPanel(panels[0], 0);
    setupPanel(panels[1], 1);
  }

  /* ────────────────────────────────────────────
     PANORAMIC MODE
     ──────────────────────────────────────────── */
  function initPanoramic() {
    var container = document.querySelector('[data-panoramic]');
    if (!container) return;

    var imgs = container.querySelectorAll('.bold-hero__panoramic-img');
    var hero = document.querySelector('[data-hero]');
    if (!imgs.length || !hero) return;

    var currentIdx = 0;
    var PAN_DURATION = 7000;
    var parallaxStrength = 0.3;
    var panStartTime = performance.now();
    var lastCycle = 0;

    function sizeImage(img) {
      var imgW = img.naturalWidth || img.offsetWidth;
      var imgH = img.naturalHeight || img.offsetHeight;
      var viewW = hero.offsetWidth;
      var viewH = hero.offsetHeight;

      var minDisplayW = viewW * 1.4;
      var scaleByHeight = (viewH * 1.05) / imgH;
      var scaleByWidth = minDisplayW / imgW;
      var scale = Math.max(scaleByHeight, scaleByWidth);
      var displayW = imgW * scale;
      var displayH = imgH * scale;

      img.style.width = displayW + 'px';
      img.style.height = displayH + 'px';

      return {
        maxPanX: Math.max(0, displayW - viewW),
        maxPanY: displayH - viewH,
        offsetY: -(displayH - viewH)
      };
    }

    function start() {
      var viewH = hero.offsetHeight;
      var dims = [];
      for (var i = 0; i < imgs.length; i++) dims.push(sizeImage(imgs[i]));

      panStartTime = performance.now();
      lastCycle = 0;

      function animate(now) {
        var elapsed = now - panStartTime;
        var progress = (elapsed % PAN_DURATION) / PAN_DURATION;
        var totalCycle = Math.floor(elapsed / PAN_DURATION);

        if (imgs.length > 1 && totalCycle !== lastCycle) {
          lastCycle = totalCycle;
          var nextIdx = (currentIdx + 1) % imgs.length;
          imgs[currentIdx].classList.remove('is-active');
          imgs[nextIdx].classList.add('is-active');
          currentIdx = nextIdx;
        }

        var cycle = totalCycle % 2;
        var eased;
        if (cycle === 0) {
          eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        } else {
          var rev = 1 - progress;
          eased = rev < 0.5 ? 2 * rev * rev : 1 - Math.pow(-2 * rev + 2, 2) / 2;
        }

        var heroRect = hero.getBoundingClientRect();
        var scrollRatio = Math.max(0, Math.min(1, -heroRect.top / viewH));

        for (var i = 0; i < imgs.length; i++) {
          var d = dims[i];
          var panX = -eased * d.maxPanX;
          var panY = d.offsetY + (scrollRatio * d.maxPanY * parallaxStrength);
          imgs[i].style.transform = 'translate3d(' + panX + 'px, ' + panY + 'px, 0)';
        }
        requestAnimationFrame(animate);
      }
      requestAnimationFrame(animate);
    }

    var loaded = 0;
    function onLoad() { loaded++; if (loaded >= imgs.length) start(); }
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth > 0) onLoad();
      else imgs[i].addEventListener('load', onLoad);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(start, 200);
    });
  }

  /* ────────────────────────────────────────────
     SLIDESHOW MODE
     ──────────────────────────────────────────── */
  var IMAGE_INTERVAL = 6000;
  var slides, bars, current, timer;

  function hasVideo(s) { return !!s.querySelector('video'); }
  function getVideo(s) { return s.querySelector('video'); }
  function playVideo(s) { var v = getVideo(s); if (!v) return; v.preload = 'auto'; v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  function pauseVideo(s) { var v = getVideo(s); if (v) v.pause(); }
  function preloadNext(s) { var v = getVideo(s); if (!v) return; v.preload = 'auto'; v.currentTime = 0; v.load(); }

  function initSlideshow() {
    slides = document.querySelectorAll('.bold-hero__slide');
    bars = document.querySelectorAll('.bold-hero__progress-bar');
    if (!slides.length) return;
    current = 0;

    if (slides.length === 1) {
      var sv = getVideo(slides[0]);
      if (sv) sv.loop = true;
      return;
    }

    slides.forEach(function(s) { var v = getVideo(s); if (v) { v.removeAttribute('loop'); v.loop = false; } });
    slides.forEach(function(s, idx) { var v = getVideo(s); if (v) v.addEventListener('ended', function() { if (idx === current) advance(); }); });
    if (slides.length > 1) preloadNext(slides[1]);
    if (hasVideo(slides[0])) playVideo(slides[0]);
    else timer = setTimeout(advance, IMAGE_INTERVAL);
  }

  function advance() {
    clearTimeout(timer);
    var next = (current + 1) % slides.length;
    var cV = hasVideo(slides[current]), nV = hasVideo(slides[next]);
    pauseVideo(slides[current]);

    if (cV && nV) {
      slides[current].classList.remove('is-active', 'is-leaving');
      slides[current].style.transition = 'none';
      slides[next].style.transition = 'none';
      slides[next].classList.add('is-active');
      requestAnimationFrame(function() { requestAnimationFrame(function() {
        slides[current === 0 ? slides.length - 1 : current].style.transition = '';
        slides[next].style.transition = '';
      }); });
    } else {
      slides[current].classList.remove('is-active');
      slides[current].classList.add('is-leaving');
      slides[next].classList.add('is-active');
      slides[next].classList.remove('is-leaving');
      var prev = current;
      setTimeout(function() { slides[prev].classList.remove('is-leaving'); }, 2500);
    }

    bars[current].classList.remove('is-active');
    bars[current].classList.add('is-done');
    bars[next].classList.remove('is-done');
    bars[next].classList.add('is-active');
    if (next === 0) { bars.forEach(function(b) { b.classList.remove('is-done'); }); bars[0].classList.add('is-active'); }

    current = next;
    if (nV) playVideo(slides[current]);
    else timer = setTimeout(advance, IMAGE_INTERVAL);

    var afterNext = (current + 1) % slides.length;
    preloadNext(slides[afterNext]);
    var prevIdx = (current - 1 + slides.length) % slides.length;
    var pv = getVideo(slides[prevIdx]);
    if (pv) pv.currentTime = 0;
  }

  /* ────────────────────────────────────────────
     INIT
     ──────────────────────────────────────────── */
  function init() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;

    if (hero.classList.contains('bold-hero--split')) {
      initSplit();
    } else if (hero.classList.contains('bold-hero--panoramic')) {
      initPanoramic();
    } else {
      initSlideshow();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
